export default __webpack_public_path__ + "static/media/review.76019b54.svg";